import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'

export const PaperComponent = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  backgroundColor: theme.palette.grey['900'],
}))

export const ULComponent = styled('ul')(() => ({
  display: 'flex',
  marginBottom: 0,
  listStyle: 'none',
}))

export const LIComponent = styled('li')(() => ({
  textAlign: 'center',
  border: '1px solid black',
  padding: 5,
  marginRight: 1,
  width: 96,
  height: 110,
  cursor: 'pointer',
}))
